import {Link} from '@pepsico-ds/ui';
export default Link;
